export default __webpack_public_path__ + "static/media/Touch-App-Geraeteabbildung_ULTRAMAT_6_1_675x267px.207bc81a.png";